module.exports = __webpack_public_path__ + "fonts/Stelvio-Grotesk-Bold.05fb33e.woff2";